import React from 'react';
import {Trans} from 'gatsby-plugin-react-i18next';
import {MenuLink} from '../utils/types';

export const mainProducts: MenuLink[] = [
  {icon: 'globe', slug: 'online-payments', title: <Trans>Online payments</Trans>},
  {icon: 'card', slug: 'payment-gateway', title: <Trans>Payment Gateway</Trans>},
  {icon: 'pay-by-link', slug: 'features/pay-by-link', title: 'Pay By Link'},
  {icon: 'mobile', slug: 'tpv-virtual', title: 'TPV Virtual'},
  {
    icon: 'recurring',
    slug: 'features/recurring-payments',
    title: <Trans>Recurring payments</Trans>
  },
  {icon: 'subscriptions', slug: 'features/subscriptions', title: <Trans>Subscriptions</Trans>},
  {icon: 'api-integration', slug: 'connect', title: 'MONEI Connect'},
  {icon: 'whatsapp', slug: 'features/whatsapp-payments', title: <Trans>WhatsApp payments</Trans>}
];

export const physicalPayments: MenuLink[] = [
  {icon: 'qr-icon', slug: 'monei-pay/qr', title: <Trans>QR Code Payments</Trans>},
  {icon: 'freelancer', slug: 'monei-pay', title: 'MONEI Pay'},
  {icon: 'monei-pod', slug: 'monei-pay/monei-pod', title: 'MONEI Pod'}
];

export const advantages: MenuLink[] = [
  {
    icon: 'ivan',
    to: 'https://docs.monei.com/docs/integrations/use-prebuilt-payment-page/',
    title: <Trans>Hosted Payment Page</Trans>
  },
  {
    icon: 'fast-checkout',
    to: 'https://docs.monei.com/docs/integrations/build-custom-checkout/',
    title: <Trans>Custom Checkout</Trans>
  },
  {
    icon: 'network-tokenization',
    slug: 'features/network-tokenization',
    title: <Trans>Network Tokenization</Trans>
  },
  {
    icon: 'payments-orchestration',
    slug: 'features/payments-orchestration',
    title: <Trans>Payments Orchestration</Trans>
  },
  {icon: 'card', slug: 'pci-dss', title: 'PCI DSS Level 1'}
];
